import { ISearchBar } from '../state';
import {
  TourSearchBarActionType,
  TourSearchBarActions,
  ITourSearchBarState,
} from '../types/tour';

export const tourReducer = (
  state: ISearchBar,
  action: TourSearchBarActions
): { tour: ITourSearchBarState } => {
  const { type, payload } = action;

  switch (type) {
    case TourSearchBarActionType.SET_SEARCH_DATA:
      return {
        tour: {
          ...state.tour,
          searchData: payload,
        },
      };

    case TourSearchBarActionType.SET_HREF:
      return {
        tour: {
          ...state.tour,
          href: payload,
        },
      };

    case TourSearchBarActionType.SET_ALL:
      return {
        tour: {
          ...state.tour,
          ...payload,
        },
      };

    case TourSearchBarActionType.SET_IS_SEARCH_DATA_ERROR:
      return {
        tour: {
          ...state.tour,
          isSearchDataError: payload,
        },
      };
    case TourSearchBarActionType.SET_ALL_RESULTS_URL:
      return {
        tour: {
          ...state.tour,
          allResultsURL: payload,
        },
      };

    default:
      return {
        tour: {
          ...state.tour,
        },
      };
  }
};
